module.exports = __webpack_public_path__ + "img/dwarf_5.33ad3bd9.png";